exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tooltip-wrapper{position:relative;line-height:normal;display:block;height:30px}.tooltip-wrapper--on-hover .tooltip-content__wrapper{display:none}.tooltip-wrapper--on-hover:hover .tooltip-content__wrapper{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./common/components/tooltip/_style.scss
// module id = 865
// module chunks = 0